import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const getAdvertisements = createAsyncThunk(
  "get_advertisements",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/advertisements/`
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const getSocialLinks = createAsyncThunk(
  "get_social_links",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/social_links/`
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);
